import { render, staticRenderFns } from "./tab-3.vue?vue&type=template&id=1325e00c"
import script from "./tab-3.vue?vue&type=script&lang=js"
export * from "./tab-3.vue?vue&type=script&lang=js"
import style0 from "./tab-3.vue?vue&type=style&index=0&id=1325e00c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports